export default "__VITE_ASSET__mwCv0f5M__"